import React from "react";
import { withSiteData } from "react-static";
//
import Footer from "components/footer";
//
export default withSiteData(({ footer }) => <Footer {...footer} />);
